import type { Lang } from './types';

/**
 * Static UI strings of the visitor site (labels around the managed content). Page content itself is managed
 * per language in the CMS. Every key exists in all four languages.
 */
const de = {
  phone: 'Telefonnummer',
  address: 'Adresse',
  workingHours: 'Arbeitszeit',
  whatsapp: 'WhatsApp',
  contact: 'Kontakt',
  services: 'Dienstleistungen',
  ourExpert: 'Unser Gutachter',
  contactForm: 'Kontaktformular',
  phoneFooter: 'Telefonnummer',
  start: 'Start',
  menu: 'Menü',
  toggleNavigation: 'Navigation öffnen',
  toggleSubmenu: 'Untermenü öffnen',
  backToTop: 'Nach oben',
  language: 'Sprache',
  sliderLabel: 'Bildergalerie',
  previousSlide: 'Vorheriges Bild',
  nextSlide: 'Nächstes Bild',
  pauseSlider: 'Automatische Wiedergabe anhalten',
  playSlider: 'Automatische Wiedergabe starten',
  slideOf: 'Bild {n} von {total}',
  previous: 'Zurück',
  next: 'Weiter',
  formName: 'Name',
  formEmail: 'Email',
  formPhone: 'Telefonnummer',
  formPlate: 'Kennzeichen',
  formMessage: 'Nachricht',
  formSending: 'Warten Sie...',
  formSuccess: 'Vielen Dank! Ihre Anfrage wurde gesendet.',
  formError: 'Die Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es später erneut oder rufen Sie uns an.',
  formExpired: 'Das Formular ist abgelaufen. Bitte laden Sie die Seite neu.',
  formTooMany: 'Zu viele Anfragen. Bitte versuchen Sie es in einigen Minuten erneut.',
  formInvalid: 'Bitte prüfen Sie die markierten Felder.',
  fieldRequired: 'Dieses Feld ist erforderlich.',
  fieldEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
  fieldPhone: 'Bitte geben Sie eine gültige Telefonnummer ein.',
  fieldMessage: 'Bitte geben Sie eine Nachricht ein (mindestens 5 Zeichen).',
  mapConsent: 'Die Karte wird von Google Maps geladen. Dabei werden Daten an Google übertragen.',
  mapLoad: 'Karte laden',
  mapOpen: 'In Google Maps öffnen',
  notFoundTitle: 'Seite nicht gefunden',
  notFoundText: 'Die angeforderte Seite existiert nicht oder ist in dieser Sprache nicht verfügbar.',
  toHome: 'Zur Startseite',
  cookieTitle: 'Cookie-Einstellungen',
  cookieText:
    'Wir verwenden notwendige Cookies für den Betrieb dieser Website. Mit Ihrer Zustimmung verwenden wir außerdem Dienste für Statistik, Marketing und eingebettete Inhalte wie Google Maps.',
  cookieNecessary: 'Notwendige Cookies',
  cookieAnalytics: 'Statistik / Analytics',
  cookieMarketing: 'Marketing / Google Ads / Google Maps',
  cookieAcceptAll: 'Alle akzeptieren',
  cookieRejectAll: 'Alle ablehnen',
  cookieSettings: 'Einstellungen',
  cookieSave: 'Auswahl speichern',
  previewBanner: 'Vorschau – nicht veröffentlichte Version',
  ratingLabel: '{n} von 5 Sternen',
  captchaFailed: 'Die Sicherheitsprüfung ist fehlgeschlagen. Bitte versuchen Sie es erneut.',
  formUnavailable: 'Online-Anfragen sind gerade nicht möglich. Bitte rufen Sie uns an.',
  recaptchaNotice: 'Dieses Formular ist durch Google reCAPTCHA geschützt. Es gelten die Datenschutzerklärung und die Nutzungsbedingungen von Google.',
  apStepSlot: '1. Termin wählen',
  apStepVehicle: '2. Fahrzeug & Anliegen',
  apStepDetails: '3. Ihre Angaben',
  apPrevDays: 'Frühere Tage',
  apNextDays: 'Spätere Tage',
  apLoading: 'Freie Zeiten werden geladen…',
  apLoadError: 'Die freien Zeiten konnten nicht geladen werden.',
  apRetry: 'Erneut versuchen',
  apLegend: 'Legende',
  apAvailable: 'frei',
  apLimited: 'wenige frei',
  apFull: 'belegt',
  apClosed: 'geschlossen',
  apHoliday: 'Feiertag',
  apDayFull: 'ausgebucht',
  apDayPast: 'nicht mehr buchbar',
  apNoSlots: 'In diesem Zeitraum sind keine Zeiten frei. Bitte blättern Sie weiter oder rufen Sie uns an.',
  apTimeZone: 'Alle Zeiten in Ortszeit ({tz}).',
  apSelected: 'Gewählter Termin',
  apSelectSlot: 'Bitte wählen Sie einen freien Termin.',
  apChange: 'ändern',
  apDays: 'Tage',
  apTopics: 'Anliegen (optional, Mehrfachauswahl)',
  apTopicsSearch: 'Anliegen suchen',
  apRemove: '{name} entfernen',
  apNoOptions: 'Keine Treffer',
  apYear: 'Baujahr',
  apMake: 'Marke',
  apModel: 'Modell',
  apSearchPlaceholder: 'Tippen zum Suchen…',
  apSelectYearFirst: 'Bitte zuerst das Baujahr wählen',
  apSelectMakeFirst: 'Bitte zuerst die Marke wählen',
  apNotListed: 'Mein Fahrzeug ist nicht in der Liste',
  apMakeText: 'Marke (Freitext)',
  apModelText: 'Modell (Freitext)',
  apVehicleNote: 'Hinweis zum Fahrzeug (optional)',
  apName: 'Name',
  apPhone: 'Telefonnummer',
  apEmail: 'E-Mail (optional)',
  apPlate: 'Kennzeichen',
  apMessage: 'Beschreibung Ihres Anliegens',
  apRequired: 'Pflichtfeld',
  apChannels: 'Benachrichtigung erhalten per',
  apChannelEmail: 'E-Mail',
  apChannelSms: 'SMS',
  apChannelWhatsApp: 'WhatsApp',
  apChannelHint: 'Nur wenn Sie es wünschen. SMS und WhatsApp werden nur genutzt, wenn der Kanal bei uns verfügbar ist.',
  apSubmitting: 'Anfrage wird gesendet…',
  apSuccessTitle: 'Anfrage eingegangen – wartet auf Bestätigung',
  apSuccessText: 'Ihre Anfrage für {time} wurde übermittelt. Sie ist noch keine Terminbestätigung – wir prüfen die Anfrage und melden uns bei Ihnen.',
  apReference: 'Ihre Referenznummer',
  apNewRequest: 'Weitere Anfrage stellen',
  apSlotTaken: 'Der gewählte Termin ist nicht mehr verfügbar. Bitte wählen Sie einen anderen.',
  apTooMany: 'Es gibt bereits mehrere offene Anfragen. Bitte rufen Sie uns an.',
  apYearMismatch: 'Das Modell passt nicht zum Baujahr.',
  apEmailForNotify: 'Für Benachrichtigungen per E-Mail ist eine E-Mail-Adresse nötig.',
  apPlateInvalid: 'Bitte geben Sie ein gültiges Kennzeichen ein.',
  apEditorNote: 'Vorschau: Anfragen können im Editor nicht gesendet werden.',
};

export type UiKey = keyof typeof de;

const tr: Record<UiKey, string> = {
  phone: 'Telefon',
  address: 'Adres',
  workingHours: 'Çalışma saatleri',
  whatsapp: 'WhatsApp',
  contact: 'İletişim',
  services: 'Hizmetler',
  ourExpert: 'Bilirkişimiz',
  contactForm: 'İletişim formu',
  phoneFooter: 'Telefon',
  start: 'Ana sayfa',
  menu: 'Menü',
  toggleNavigation: 'Menüyü aç',
  toggleSubmenu: 'Alt menüyü aç',
  backToTop: 'Yukarı çık',
  language: 'Dil',
  sliderLabel: 'Görsel galerisi',
  previousSlide: 'Önceki görsel',
  nextSlide: 'Sonraki görsel',
  pauseSlider: 'Otomatik oynatmayı durdur',
  playSlider: 'Otomatik oynatmayı başlat',
  slideOf: 'Görsel {n} / {total}',
  previous: 'Geri',
  next: 'İleri',
  formName: 'Ad Soyad',
  formEmail: 'E-posta',
  formPhone: 'Telefon',
  formPlate: 'Plaka',
  formMessage: 'Mesaj',
  formSending: 'Lütfen bekleyin...',
  formSuccess: 'Teşekkürler! Talebiniz gönderildi.',
  formError: 'Mesaj gönderilemedi. Lütfen daha sonra tekrar deneyin veya bizi arayın.',
  formExpired: 'Formun süresi doldu. Lütfen sayfayı yenileyin.',
  formTooMany: 'Çok fazla istek. Lütfen birkaç dakika sonra tekrar deneyin.',
  formInvalid: 'Lütfen işaretli alanları kontrol edin.',
  fieldRequired: 'Bu alan zorunludur.',
  fieldEmail: 'Lütfen geçerli bir e-posta adresi girin.',
  fieldPhone: 'Lütfen geçerli bir telefon numarası girin.',
  fieldMessage: 'Lütfen bir mesaj yazın (en az 5 karakter).',
  mapConsent: 'Harita Google Maps üzerinden yüklenir. Bu sırada Google’a veri aktarılır.',
  mapLoad: 'Haritayı yükle',
  mapOpen: 'Google Maps’te aç',
  notFoundTitle: 'Sayfa bulunamadı',
  notFoundText: 'İstenen sayfa mevcut değil veya bu dilde yayında değil.',
  toHome: 'Ana sayfaya dön',
  cookieTitle: 'Çerez ayarları',
  cookieText:
    'Bu sitenin çalışması için zorunlu çerezler kullanıyoruz. Onayınızla istatistik, pazarlama ve Google Maps gibi gömülü içerik hizmetlerini de kullanırız.',
  cookieNecessary: 'Zorunlu çerezler',
  cookieAnalytics: 'İstatistik / Analitik',
  cookieMarketing: 'Pazarlama / Google Ads / Google Maps',
  cookieAcceptAll: 'Tümünü kabul et',
  cookieRejectAll: 'Tümünü reddet',
  cookieSettings: 'Ayarlar',
  cookieSave: 'Seçimi kaydet',
  previewBanner: 'Önizleme – yayınlanmamış sürüm',
  ratingLabel: '5 üzerinden {n} yıldız',
  captchaFailed: 'Güvenlik doğrulaması başarısız oldu. Lütfen tekrar deneyin.',
  formUnavailable: 'Çevrim içi talepler şu anda mümkün değil. Lütfen bizi arayın.',
  recaptchaNotice: 'Bu form Google reCAPTCHA ile korunmaktadır. Google Gizlilik Politikası ve Hizmet Şartları geçerlidir.',
  apStepSlot: '1. Zaman seçin',
  apStepVehicle: '2. Araç ve konu',
  apStepDetails: '3. Bilgileriniz',
  apPrevDays: 'Önceki günler',
  apNextDays: 'Sonraki günler',
  apLoading: 'Uygun zamanlar yükleniyor…',
  apLoadError: 'Uygun zamanlar yüklenemedi.',
  apRetry: 'Tekrar dene',
  apLegend: 'Açıklama',
  apAvailable: 'uygun',
  apLimited: 'az yer',
  apFull: 'dolu',
  apClosed: 'kapalı',
  apHoliday: 'tatil',
  apDayFull: 'tamamen dolu',
  apDayPast: 'artık seçilemez',
  apNoSlots: 'Bu aralıkta uygun zaman yok. Lütfen ileri gidin veya bizi arayın.',
  apTimeZone: 'Tüm saatler yerel saattir ({tz}).',
  apSelected: 'Seçilen zaman',
  apSelectSlot: 'Lütfen uygun bir zaman seçin.',
  apChange: 'değiştir',
  apDays: 'Günler',
  apTopics: 'Konu (isteğe bağlı, çoklu seçim)',
  apTopicsSearch: 'Konu ara',
  apRemove: '{name} kaldır',
  apNoOptions: 'Sonuç yok',
  apYear: 'Model yılı',
  apMake: 'Marka',
  apModel: 'Model',
  apSearchPlaceholder: 'Aramak için yazın…',
  apSelectYearFirst: 'Önce model yılını seçin',
  apSelectMakeFirst: 'Önce markayı seçin',
  apNotListed: 'Aracım listede yok',
  apMakeText: 'Marka (serbest metin)',
  apModelText: 'Model (serbest metin)',
  apVehicleNote: 'Araç hakkında not (isteğe bağlı)',
  apName: 'Ad Soyad',
  apPhone: 'Telefon',
  apEmail: 'E-posta (isteğe bağlı)',
  apPlate: 'Plaka',
  apMessage: 'Talebinizin açıklaması',
  apRequired: 'zorunlu',
  apChannels: 'Bildirim almak istediğim kanal',
  apChannelEmail: 'E-posta',
  apChannelSms: 'SMS',
  apChannelWhatsApp: 'WhatsApp',
  apChannelHint: 'Yalnızca isterseniz. SMS ve WhatsApp yalnızca bizde kullanılabilir olduğunda gönderilir.',
  apSubmitting: 'Talep gönderiliyor…',
  apSuccessTitle: 'Talebiniz alındı – onay bekleniyor',
  apSuccessText: '{time} için talebiniz iletildi. Bu henüz bir randevu onayı değildir – talebi inceleyip size dönüş yapacağız.',
  apReference: 'Referans numaranız',
  apNewRequest: 'Yeni talep oluştur',
  apSlotTaken: 'Seçilen zaman artık uygun değil. Lütfen başka bir zaman seçin.',
  apTooMany: 'Zaten açık talepleriniz var. Lütfen bizi arayın.',
  apYearMismatch: 'Model, model yılıyla uyuşmuyor.',
  apEmailForNotify: 'E-posta bildirimi için e-posta adresi gereklidir.',
  apPlateInvalid: 'Lütfen geçerli bir plaka girin.',
  apEditorNote: 'Önizleme: Editörde talep gönderilemez.',
};

const en: Record<UiKey, string> = {
  phone: 'Phone',
  address: 'Address',
  workingHours: 'Opening hours',
  whatsapp: 'WhatsApp',
  contact: 'Contact',
  services: 'Services',
  ourExpert: 'Our expert',
  contactForm: 'Contact form',
  phoneFooter: 'Phone',
  start: 'Home',
  menu: 'Menu',
  toggleNavigation: 'Open navigation',
  toggleSubmenu: 'Open submenu',
  backToTop: 'Back to top',
  language: 'Language',
  sliderLabel: 'Image gallery',
  previousSlide: 'Previous image',
  nextSlide: 'Next image',
  pauseSlider: 'Pause autoplay',
  playSlider: 'Start autoplay',
  slideOf: 'Image {n} of {total}',
  previous: 'Previous',
  next: 'Next',
  formName: 'Name',
  formEmail: 'Email',
  formPhone: 'Phone number',
  formPlate: 'Licence plate',
  formMessage: 'Message',
  formSending: 'Please wait...',
  formSuccess: 'Thank you! Your request has been sent.',
  formError: 'Your message could not be sent. Please try again later or give us a call.',
  formExpired: 'The form has expired. Please reload the page.',
  formTooMany: 'Too many requests. Please try again in a few minutes.',
  formInvalid: 'Please check the highlighted fields.',
  fieldRequired: 'This field is required.',
  fieldEmail: 'Please enter a valid email address.',
  fieldPhone: 'Please enter a valid phone number.',
  fieldMessage: 'Please enter a message (at least 5 characters).',
  mapConsent: 'The map is loaded from Google Maps, which transfers data to Google.',
  mapLoad: 'Load map',
  mapOpen: 'Open in Google Maps',
  notFoundTitle: 'Page not found',
  notFoundText: 'The requested page does not exist or is not available in this language.',
  toHome: 'Go to home page',
  cookieTitle: 'Cookie settings',
  cookieText:
    'We use necessary cookies to run this website. With your consent we also use services for statistics, marketing and embedded content such as Google Maps.',
  cookieNecessary: 'Necessary cookies',
  cookieAnalytics: 'Statistics / Analytics',
  cookieMarketing: 'Marketing / Google Ads / Google Maps',
  cookieAcceptAll: 'Accept all',
  cookieRejectAll: 'Reject all',
  cookieSettings: 'Settings',
  cookieSave: 'Save selection',
  previewBanner: 'Preview – unpublished version',
  ratingLabel: '{n} out of 5 stars',
  captchaFailed: 'The security check failed. Please try again.',
  formUnavailable: 'Online requests are currently not possible. Please call us.',
  recaptchaNotice: 'This form is protected by Google reCAPTCHA. The Google Privacy Policy and Terms of Service apply.',
  apStepSlot: '1. Choose a time',
  apStepVehicle: '2. Vehicle & topic',
  apStepDetails: '3. Your details',
  apPrevDays: 'Earlier days',
  apNextDays: 'Later days',
  apLoading: 'Loading available times…',
  apLoadError: 'Available times could not be loaded.',
  apRetry: 'Try again',
  apLegend: 'Legend',
  apAvailable: 'available',
  apLimited: 'few left',
  apFull: 'booked',
  apClosed: 'closed',
  apHoliday: 'holiday',
  apDayFull: 'fully booked',
  apDayPast: 'no longer bookable',
  apNoSlots: 'No times are available in this period. Please look further ahead or call us.',
  apTimeZone: 'All times are local time ({tz}).',
  apSelected: 'Selected time',
  apSelectSlot: 'Please choose an available time.',
  apChange: 'change',
  apDays: 'Days',
  apTopics: 'Topic (optional, multiple choice)',
  apTopicsSearch: 'Search topics',
  apRemove: 'Remove {name}',
  apNoOptions: 'No matches',
  apYear: 'Year of manufacture',
  apMake: 'Make',
  apModel: 'Model',
  apSearchPlaceholder: 'Type to search…',
  apSelectYearFirst: 'Choose the year first',
  apSelectMakeFirst: 'Choose the make first',
  apNotListed: 'My vehicle is not in the list',
  apMakeText: 'Make (free text)',
  apModelText: 'Model (free text)',
  apVehicleNote: 'Note about the vehicle (optional)',
  apName: 'Name',
  apPhone: 'Phone number',
  apEmail: 'Email (optional)',
  apPlate: 'Licence plate',
  apMessage: 'Describe your request',
  apRequired: 'required',
  apChannels: 'Notify me by',
  apChannelEmail: 'Email',
  apChannelSms: 'SMS',
  apChannelWhatsApp: 'WhatsApp',
  apChannelHint: 'Only if you wish. SMS and WhatsApp are only used when the channel is available on our side.',
  apSubmitting: 'Sending request…',
  apSuccessTitle: 'Request received – awaiting confirmation',
  apSuccessText: 'Your request for {time} has been sent. It is not yet a confirmed appointment – we will review it and get back to you.',
  apReference: 'Your reference number',
  apNewRequest: 'Make another request',
  apSlotTaken: 'The selected time is no longer available. Please choose another one.',
  apTooMany: 'There are already several open requests. Please call us.',
  apYearMismatch: 'The model does not match the year.',
  apEmailForNotify: 'An email address is needed for email notifications.',
  apPlateInvalid: 'Please enter a valid licence plate.',
  apEditorNote: 'Preview: requests cannot be sent from the editor.',
};

const ru: Record<UiKey, string> = {
  phone: 'Телефон',
  address: 'Адрес',
  workingHours: 'Время работы',
  whatsapp: 'WhatsApp',
  contact: 'Контакты',
  services: 'Услуги',
  ourExpert: 'Наш эксперт',
  contactForm: 'Форма обратной связи',
  phoneFooter: 'Телефон',
  start: 'Главная',
  menu: 'Меню',
  toggleNavigation: 'Открыть меню',
  toggleSubmenu: 'Открыть подменю',
  backToTop: 'Наверх',
  language: 'Язык',
  sliderLabel: 'Галерея изображений',
  previousSlide: 'Предыдущее изображение',
  nextSlide: 'Следующее изображение',
  pauseSlider: 'Остановить автопрокрутку',
  playSlider: 'Запустить автопрокрутку',
  slideOf: 'Изображение {n} из {total}',
  previous: 'Назад',
  next: 'Далее',
  formName: 'Имя',
  formEmail: 'E-mail',
  formPhone: 'Телефон',
  formPlate: 'Госномер',
  formMessage: 'Сообщение',
  formSending: 'Пожалуйста, подождите...',
  formSuccess: 'Спасибо! Ваш запрос отправлен.',
  formError: 'Не удалось отправить сообщение. Попробуйте позже или позвоните нам.',
  formExpired: 'Срок действия формы истёк. Пожалуйста, обновите страницу.',
  formTooMany: 'Слишком много запросов. Попробуйте через несколько минут.',
  formInvalid: 'Пожалуйста, проверьте отмеченные поля.',
  fieldRequired: 'Это поле обязательно.',
  fieldEmail: 'Введите корректный адрес e-mail.',
  fieldPhone: 'Введите корректный номер телефона.',
  fieldMessage: 'Введите сообщение (не менее 5 символов).',
  mapConsent: 'Карта загружается из Google Maps, при этом данные передаются в Google.',
  mapLoad: 'Загрузить карту',
  mapOpen: 'Открыть в Google Maps',
  notFoundTitle: 'Страница не найдена',
  notFoundText: 'Запрошенная страница не существует или недоступна на этом языке.',
  toHome: 'На главную',
  cookieTitle: 'Настройки cookie',
  cookieText:
    'Мы используем необходимые cookie для работы сайта. С вашего согласия мы также используем сервисы статистики, маркетинга и встроенный контент, например Google Maps.',
  cookieNecessary: 'Необходимые cookie',
  cookieAnalytics: 'Статистика / Аналитика',
  cookieMarketing: 'Маркетинг / Google Ads / Google Maps',
  cookieAcceptAll: 'Принять все',
  cookieRejectAll: 'Отклонить все',
  cookieSettings: 'Настройки',
  cookieSave: 'Сохранить выбор',
  previewBanner: 'Предпросмотр – неопубликованная версия',
  ratingLabel: '{n} из 5 звёзд',
  captchaFailed: 'Проверка безопасности не пройдена. Попробуйте ещё раз.',
  formUnavailable: 'Онлайн-заявки сейчас недоступны. Пожалуйста, позвоните нам.',
  recaptchaNotice: 'Эта форма защищена Google reCAPTCHA. Действуют Политика конфиденциальности и Условия использования Google.',
  apStepSlot: '1. Выберите время',
  apStepVehicle: '2. Автомобиль и тема',
  apStepDetails: '3. Ваши данные',
  apPrevDays: 'Предыдущие дни',
  apNextDays: 'Следующие дни',
  apLoading: 'Загрузка свободного времени…',
  apLoadError: 'Не удалось загрузить свободное время.',
  apRetry: 'Повторить',
  apLegend: 'Обозначения',
  apAvailable: 'свободно',
  apLimited: 'мало мест',
  apFull: 'занято',
  apClosed: 'закрыто',
  apHoliday: 'праздник',
  apDayFull: 'всё занято',
  apDayPast: 'запись недоступна',
  apNoSlots: 'В этот период нет свободного времени. Посмотрите следующие дни или позвоните нам.',
  apTimeZone: 'Всё время указано по местному времени ({tz}).',
  apSelected: 'Выбранное время',
  apSelectSlot: 'Пожалуйста, выберите свободное время.',
  apChange: 'изменить',
  apDays: 'Дни',
  apTopics: 'Тема (необязательно, несколько вариантов)',
  apTopicsSearch: 'Поиск темы',
  apRemove: 'Удалить {name}',
  apNoOptions: 'Ничего не найдено',
  apYear: 'Год выпуска',
  apMake: 'Марка',
  apModel: 'Модель',
  apSearchPlaceholder: 'Введите для поиска…',
  apSelectYearFirst: 'Сначала выберите год',
  apSelectMakeFirst: 'Сначала выберите марку',
  apNotListed: 'Моего автомобиля нет в списке',
  apMakeText: 'Марка (вручную)',
  apModelText: 'Модель (вручную)',
  apVehicleNote: 'Примечание об автомобиле (необязательно)',
  apName: 'Имя',
  apPhone: 'Телефон',
  apEmail: 'E-mail (необязательно)',
  apPlate: 'Номерной знак',
  apMessage: 'Опишите ваш запрос',
  apRequired: 'обязательно',
  apChannels: 'Уведомлять меня через',
  apChannelEmail: 'E-mail',
  apChannelSms: 'SMS',
  apChannelWhatsApp: 'WhatsApp',
  apChannelHint: 'Только по вашему желанию. SMS и WhatsApp используются, только если канал у нас доступен.',
  apSubmitting: 'Отправка заявки…',
  apSuccessTitle: 'Заявка получена – ожидает подтверждения',
  apSuccessText: 'Ваша заявка на {time} отправлена. Это ещё не подтверждение записи – мы проверим заявку и свяжемся с вами.',
  apReference: 'Ваш номер заявки',
  apNewRequest: 'Отправить ещё одну заявку',
  apSlotTaken: 'Выбранное время больше недоступно. Пожалуйста, выберите другое.',
  apTooMany: 'Уже есть несколько открытых заявок. Пожалуйста, позвоните нам.',
  apYearMismatch: 'Модель не соответствует году выпуска.',
  apEmailForNotify: 'Для уведомлений по e-mail нужен адрес e-mail.',
  apPlateInvalid: 'Введите корректный номерной знак.',
  apEditorNote: 'Предпросмотр: в редакторе заявки не отправляются.',
};

export const uiStrings: Record<Lang, Record<UiKey, string>> = { de, tr, en, ru };

export function translate(lang: Lang, key: UiKey, vars?: Record<string, string | number>): string {
  let text = (uiStrings[lang] ?? uiStrings.de)[key] ?? uiStrings.de[key];
  if (vars) for (const [k, v] of Object.entries(vars)) text = text.replace(`{${k}}`, String(v));
  return text;
}
